// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form--content_social__link {
  margin: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ImageButton/ImageButton.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".login-form--content_social__link {\r\n  margin: 0 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
